import { activeTab, getVariables, queryParamsInitial, setSearchParamsToState } from '../../store';
import { MonitoringObjectsTable } from './components';
import { instructionTypeForFilter } from './store';
import { GET_MONITORING_OBJECTS } from '@/common/actions/get';
import { useDidMountEffect } from '@/common/hooks';
import {
  getFiltersFromSearchParams,
  setFilterParamsToSearchParams,
  setSortParamsToSearchParams,
} from '@/utils';
import { useLazyQuery } from '@apollo/client';
import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

const MonitoringObjectsView = ({ isShowTable }) => {
  const { id: partnerClientAccountId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [queryParams, setQueryParams] = useState({
    ...queryParamsInitial,
    filters: getFiltersFromSearchParams(Object.fromEntries([...searchParams])),
  });

  const [getMonitoringObjectsApi, { data, loading }] = useLazyQuery(GET_MONITORING_OBJECTS);

  const onPageChange = (page, size) => {
    searchParams.set('page', String(page));
    searchParams.set('pageSize', String(size));
    setSearchParams(searchParams, { replace: true });
  };

  const onSortingChange = (sortArray) => {
    searchParams.set('page', String(queryParamsInitial.page));
    setSortParamsToSearchParams(sortArray, searchParams);
    setSearchParams(searchParams, { replace: true });
  };

  const onFiltersChange = (filterList) => {
    searchParams.set('page', String(queryParamsInitial.page));
    setFilterParamsToSearchParams(filterList, searchParams);
    setSearchParams(searchParams, { replace: true });
  };

  useEffect(() => {
    setSearchParamsToState(searchParams, setQueryParams, queryParamsInitial);
  }, [searchParams]);

  useDidMountEffect(() => {
    if (queryParams.tab !== activeTab.monitoringObjects) {
      return;
    }

    const variables = getVariables(queryParams, instructionTypeForFilter);

    getMonitoringObjectsApi({
      variables: {
        ...variables,
        filterPartnerClientAccountId: Number(partnerClientAccountId),
      },
    });
  }, [queryParams]);

  if (!isShowTable) {
    return null;
  }

  return (
    <MonitoringObjectsTable
      loading={loading}
      data={data?.l3MonitoringObjects?.items || []}
      onPageChange={onPageChange}
      onSortingChange={onSortingChange}
      onFiltersChange={onFiltersChange}
      queryParams={queryParams}
      totalPages={data?.l3MonitoringObjects?.info?.totalPages || 1}
      totalCount={data?.l3MonitoringObjects?.info?.totalCount || 0}
    />
  );
};

export default MonitoringObjectsView;
